/* eslint-disable no-underscore-dangle */
import { create } from 'apisauce'

import ServerStatus from './server-status'

class APIService {
  constructor(baseURL, authToken) {
    const requestParams = {
      baseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    }

    if (authToken) {
      requestParams.headers.Authorization = `Bearer ${authToken}`
    }

    this.apiSauce = create(requestParams)
  }

  get = async (url, payload = {}, config = {}) => {
    const res = await this._handleResponse(
      this.apiSauce.get,
      { url, payload },
      config
    )
    return res
  }

  put = async (url, payload = {}) => {
    const res = await this._handleResponse(this.apiSauce.put, { url, payload })
    return res
  }

  patch = async (url, payload = {}) => {
    const res = await this._handleResponse(this.apiSauce.patch, {
      url,
      payload
    })
    return res
  }

  post = async (url, payload = {}) => {
    const res = await this._handleResponse(this.apiSauce.post, { url, payload })
    return res
  }

  delete = async (url, payload = {}) => {
    const res = await this._handleResponse(this.apiSauce.delete, {
      url,
      payload
    })
    return res
  }

  _handleResponse = async (apiRequest, params, config) => {
    const response = await apiRequest(params.url, params.payload)

    return this._handleError(response, params, config)
  }

  _handleError = (response, params, config = {}) => {
    if (response.status === ServerStatus.unauthorized) {
      console.log('TokenExpired')
      // TODO: Handle - FireTokenExpiredAction()
    }

    const { ok, problem, status } = response

    if (!ok && problem === ServerStatus.network_error) {
      console.log('ConnectivityError')
      // TODO: Handle - FireConnectivityErrorAction()
    }

    if (!ok && problem === ServerStatus.timeout) {
      console.log('TimeoutError')
      // TODO: Handle - FireServerErrorAction()
    }

    const {
      server_failed: serverFailed,
      unauthorized,
      not_found: notFound,
      bad_request: badRequest,
      service_unavailable: serviceUnavailable
    } = ServerStatus

    const errorsHandled = [
      serverFailed,
      unauthorized,
      badRequest,
      serviceUnavailable
    ]

    if (!config || !config.skip404) {
      errorsHandled.push(notFound)
    }

    let responsePayload = response

    if (response && response.data) {
      responsePayload = response.data
    }

    const formattedResponse = {
      success: !errorsHandled.includes(status),
      status,
      requestParams: params,
      responsePayload
    }

    if (!formattedResponse.success) {
      console.log('ServerError')
    }

    return formattedResponse
  }
}

export default APIService
